import React from 'react';
import { spinnerContainer, spinner } from './Spinner.css';

function Spinner() {
  return (
    <div className={spinnerContainer} role="status" aria-label="Loading">
      <div className={spinner} />
    </div>
  );
}

export default Spinner;
